var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pencil-sparkle, magic pencil, magic brush"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.33333 7.33333L5.5 5L6.66667 7.33333L9 8.5L6.66667 9.66667L5.5 12L4.33333 9.66667L2 8.5L4.33333 7.33333Z",
    fill: "#156528"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.66667 3.66667L9.5 2L10.3333 3.66667L12 4.5L10.3333 5.33333L9.5 7L8.66667 5.33333L7 4.5L8.66667 3.66667Z",
    fill: "#156528"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3666 5.95239L19.0476 2.63341L9.17538 11.218C11.4188 11.8147 13.1853 13.5812 13.782 15.8246L22.3666 5.95239Z",
    fill: "#156528"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 13C5.01472 13 3 15.0147 3 17.5V22H7.5C9.98528 22 12 19.9853 12 17.5C12 15.0147 9.98528 13 7.5 13Z",
    fill: "#156528"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.3a4484c0996f66a6d6abd1e6a7728042.svg";
export { ForwardRef as ReactComponent };